import React from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';

function BaasicModalTemplate({ modalParams, children, wrapperClass, ...other }) {
    return (
        <Modal
            overlayClassName={`modal__overlay${wrapperClass ? ` ${wrapperClass}` : ''}`}
            // className='modal__content'
            isOpen={modalParams.isOpen}
            {...other}
            className= {`${other.className} modal-content`}
        >
            {modalParams.data && modalParams.data.title && !modalParams.data.hideTitle && <h3 className='modal__header__title'>{modalParams.data.title}</h3>}
            {!(modalParams.data && modalParams.data.hideClose) &&
                <span
                    className='u-icon u-icon--sml u-icon--close--dark modal__icon--close'
                    onClick={modalParams.close}
                />
            }
            {React.cloneElement(children, { modalParams })}
        </Modal>
    );
}

BaasicModalTemplate.propTypes = {
    modalParams: PropTypes.object,
    children: PropTypes.any,
    wrapperClass: PropTypes.string,
    hideNavigation: PropTypes.bool
};

export default defaultTemplate(BaasicModalTemplate);
